import { render, staticRenderFns } from "./ws-downfile.vue?vue&type=template&id=2cc51a19&scoped=true&"
import script from "./ws-downfile.vue?vue&type=script&lang=js&"
export * from "./ws-downfile.vue?vue&type=script&lang=js&"
import style0 from "./ws-downfile.vue?vue&type=style&index=0&id=2cc51a19&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc51a19",
  null
  
)

export default component.exports